import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CreditNoteResponseDto } from "../../shared/dtos/creditNote/CreditNoteResponseDto";
import { CreditNoteSummaryDto } from "../../shared/dtos/creditNote/CreditNoteSummaryDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

const initialState = {
  ...getInitialCrudState<CreditNoteResponseDto, CreditNoteSummaryDto>(),

  loadingApply: false,
  loadingVoid: false,
  loadingPdf: false,
  loadingEmail: false,

  errorApply: null as string | null,
  errorVoid: null as string | null,
  errorPdf: null as string | null,
  errorEmail: null as string | null,

  pdfUrl: null as string | null,
};

export const creditNoteSlice = createSlice({
  name: "creditNote",
  initialState,
  reducers: {
    ...generateCrudReducers<CreditNoteResponseDto, CreditNoteSummaryDto>(),

    setLoadingApply(state) {
      state.loadingApply = true;
      state.errorApply = null;
    },
    setLoadingVoid(state) {
      state.loadingVoid = true;
      state.errorVoid = null;
    },
    setLoadingPdf(state) {
      state.loadingPdf = true;
      state.errorPdf = null;
    },
    setLoadingEmail(state) {
      state.loadingEmail = true;
      state.errorEmail = null;
    },

    setErrorApply(state, action: PayloadAction<string | null>) {
      state.loadingApply = false;
      state.errorApply = action.payload;
    },
    setErrorVoid(state, action: PayloadAction<string | null>) {
      state.loadingVoid = false;
      state.errorVoid = action.payload;
    },
    setErrorPdf(state, action: PayloadAction<string | null>) {
      state.loadingPdf = false;
      state.errorPdf = action.payload;
    },
    setErrorEmail(state, action: PayloadAction<string | null>) {
      state.loadingEmail = false;
      state.errorEmail = action.payload;
    },

    setPdfUrl(state, action: PayloadAction<string>) {
      state.loadingPdf = false;
      state.pdfUrl = action.payload;
    },
    clearPdfUrl(state) {
      if (state.pdfUrl) {
        URL.revokeObjectURL(state.pdfUrl);
      }
      state.pdfUrl = null;
    },
    setEmailSuccess(state) {
      state.loadingEmail = false;
    },
    actionSuccess(state, action: PayloadAction<CreditNoteResponseDto>) {
      state.loadingApply = false;
      state.loadingVoid = false;
      state.item = action.payload;
    },
  },
});

export const creditNoteActions = creditNoteSlice.actions;
export default creditNoteSlice.reducer;
